import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core'
import { FormArray, FormGroup } from '@angular/forms'
import { SelectOptionsService } from '@app/shared/services/select-options.service'
import { Address } from '@app/modules/address/address.model'
import { AddressFormService } from '@app/modules/address/address-form.service'
import { DeleteIdFormService } from '@app/modules/delete-id/delete-id-form.service'
import { ValidationService } from '@app/shared/services/validation.service'

@Component({
  selector: 'app-addresses-form-array',
  templateUrl: './addresses-form-array.component.html'
})

export class AddressesFormArrayComponent implements OnInit, OnDestroy {

  /**
   * Display page
   */
  public display: boolean

  /**
   * Heading text
   */
  @Input() headingText: string

  /**
   * Button text
   */
  @Input() buttonText: string

  /**
   * Main form
   */
  @Input() mainForm: FormGroup

  /**
   * Main form change
   */
  @Output() mainFormChange: EventEmitter<FormGroup> = new EventEmitter<FormGroup>()

  /**
   * Constructor
   */
  public constructor (
    public selectOptionsService: SelectOptionsService,
    private addressFormService: AddressFormService,
    private deleteIdFormService: DeleteIdFormService,
    public validationService: ValidationService
  ) {}

  /**
   * On destroy
   */
  public ngOnDestroy (): void {}

  /**
   * On init
   */
  public ngOnInit (): void {
    this.display = true
  }

  /**
   * Add
   */
  public add (): void {
    const control: FormArray = this.mainForm.get('addresses') as FormArray
    const address: Address = new Address()
    const form: FormGroup = this.addressFormService.getForm(address, 'new')
    control.push(form)
    this.mainForm.markAsDirty()
  }

  /**
   * Remove
   *
   * @param {FormGroup} item Address
   */
  public remove (item: FormGroup): void {
    const control: FormArray = this.mainForm.get('addresses') as FormArray
    const index: number = control.controls.findIndex(x => x === item)
    const address: Address = new Address(item.value)

    if (address.uuid) {
      // Mark it for delete.
      const deleted: FormArray = this.mainForm.get('addressesDeleted') as FormArray
      deleted.push(this.deleteIdFormService.getForm({ uuid: address.uuid }))
    }

    control.removeAt(index)
    this.mainForm.markAsDirty()
  }

}
